import {
  trigger,
  transition,
  query,
  style,
  animate,
} from "@angular/animations";

export const fadeAnimation = trigger("fadeAnimation", [
  transition("* => *", [
    query(":enter", [style({ opacity: 0, visibility: 'hidden', position: "absolute" })], {
      optional: true,
    }),
    query(
      ":leave",
      [
        style({ opacity: 1 }),
        animate("0.1s", style({ opacity: 0, visibility: 'hidden', position: "absolute" })),
      ],
      { optional: true }
    ),
    query(
      ":enter",
      [
        style({ opacity: 0 }),
        animate("0.1s", style({ opacity: 1, visibility: 'visible', position: "relative" })),
      ],
      { optional: true }
    ),
  ]),
]);
